import React from 'react';
import '../../styles/corpoClinico.css';
import Neurologista from '../../img/Neurologista.jpg'
import SemFoto from '../../img/corpoClinico/sem_foto.jpg'

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico_Psicopedagogia">Corpo Clínico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={SemFoto} alt="Dra. Virginia" />
            </div>
            <div className="info-container">
              <h3 className="nome">Virginia Pelizzoni</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Bacharel em Psicopedagogia, especialista em Psicologia Positiva e atualmente cursando o último ano da graduação em Psicologia.
                Atuo com avaliações psicopedagógicas, atendimentos a crianças e adolescentes com dificuldades e/ou transtornos de aprendizagem, além de oferecer orientações e acompanhamento às famílias, bem como consultorias para instituições de ensino.
                Possuo mais de 20 anos de experiência no atendimento a crianças, adolescentes e famílias, tanto em consultório quanto em escolas particulares."
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;